import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { RedoOutlined } from '@ant-design/icons-vue';
  import { Tooltip } from 'ant-design-vue';
  import { useTableContext } from '../../hooks/useTableContext';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'refresh-setting',
  setup(__props) {

  const table = useTableContext();

  function redo() {
    table.reload();
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tooltip), { placement: "top" }, {
    title: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.redo')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(RedoOutlined), { onClick: redo })
    ]),
    _: 1
  }))
}
}

})